var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVipLoungeServiceRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.414 11.5H6.75V14.414H13.414V11.5Z",
    fill: "#FFC629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 17.5H6C5.586 17.5 5.25 17.164 5.25 16.75C5.25 16.336 5.586 16 6 16H14.5C14.914 16 15.25 16.336 15.25 16.75C15.25 17.164 14.914 17.5 14.5 17.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5V13.5C5.5 14.604 6.396 15.5 7.5 15.5H12.5C13.604 15.5 14.5 14.604 14.5 13.5V8.5H5.5ZM13 13C13 13.552 12.552 14 12 14H8C7.448 14 7 13.552 7 13V10H13V13Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.5V10.834C15.368 10.834 15.666 11.132 15.666 11.5C15.666 11.868 15.368 12.166 15 12.166V13.5C16.104 13.5 17 12.604 17 11.5C17 10.396 16.104 9.5 15 9.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.5H14V10.834H15V9.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.166H14V13.5H15V12.166Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.73599V4.76599C10 5.00399 10.13 5.21799 10.336 5.33599C10.534 5.45199 10.668 5.66599 10.668 5.91199C10.668 6.15799 10.534 6.37199 10.336 6.48799C10.132 6.60799 10 6.82199 10 7.05799V7.08799C10 7.588 10.536 7.902 10.972 7.658C11.584 7.316 12 6.66199 12 5.90999C12 5.15799 11.586 4.50399 10.972 4.16199C10.536 3.92199 10 4.23799 10 4.73599Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.01002V5.98002C10 5.74202 9.87 5.52802 9.664 5.41002C9.466 5.29402 9.332 5.08002 9.332 4.83402C9.332 4.58802 9.466 4.37401 9.664 4.25801C9.868 4.13801 10 3.92401 10 3.68801V3.65801C10 3.15801 9.464 2.84401 9.028 3.08801C8.414 3.42601 8 4.08001 8 4.83202C8 5.58402 8.414 6.23802 9.028 6.58002C9.464 6.82202 10 6.50802 10 6.01002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLoungeServiceRefresh);
export default __webpack_public_path__ + "static/media/vip-lounge-service-refresh.14ead85ff7f7045ee528182089c3d4dc.svg";
export { ForwardRef as ReactComponent };